import React, { useState, useEffect, useMemo } from 'react'
import styled from "styled-components"
import {useSelector} from "react-redux"
import ChannelEpgBar from "./ChannelEpgBar"
import DB from "../../other/local-db"

import {getSingleEpgNow, downloadEpgData} from "../../other/epg-database"

const dateFormat = require("dateformat");

const ChannelInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
  gap: 0.35rem;
`

const TopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-height: 3rem;
`

const ChannelName = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;

  @media (max-width: 900px) {
    font-size: 1.15rem;
  }
`

const Favorite = styled.div`
  width: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${(props) => (props.$active ? '#ffd60a' : '#829196')};
  transition: color 0.2s ease;

  &:hover {
    color: #ffd60a;
  }
`

const ScheduleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.875rem;
  color: #aaa;
  min-height: 1.2rem;

  @media (max-width: 900px) {
    font-size: 1.1rem;
  }
`

const ScheduleTime = styled.span`
  flex-shrink: 0;
  font-weight: 600;
`

const ProgramTitle = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #ccc;
  font-weight: 400;
`

const ProgressWrapper = styled.div`
  width: 100%;
`

const SUFFIX_REGEX = /(FULL\s*HD|FHD|HD|SD)$/i;
const ELLIPSIS = '...';

const formatChannelName = (name, maxBaseLength = 26) => {
  if (!name) {
    return '';
  }

  const trimmed = name.trim();
  const suffixMatch = trimmed.match(SUFFIX_REGEX);
  let suffix = '';
  let baseName = trimmed;

  if (suffixMatch) {
    suffix = suffixMatch[0].replace(/\s+/g, ' ').toUpperCase();
    baseName = trimmed.slice(0, trimmed.length - suffixMatch[0].length).trim();
  }

  if (baseName.length <= maxBaseLength) {
    return suffix ? `${baseName} ${suffix}` : baseName;
  }

  const sliceLength = Math.max(0, maxBaseLength - ELLIPSIS.length);
  const truncatedBase = baseName.slice(0, sliceLength).trimEnd();
  return suffix ? `${truncatedBase}${ELLIPSIS} ${suffix}` : `${truncatedBase}${ELLIPSIS}`;
};

const ChannelEpg = ({chId, Name, Epg, Shift, isPlaying}) => {
    const h24Format = useSelector(state => state.h24);
    const timer = useSelector(state => state.timer60);
    const [epgNow, setEpgNow] = useState(false);
    const [favorite, setFavorite] = useState(null)

    useEffect(() => {
        setFavorite(!!DB.findOne("live",chId,true))
        if(!Epg)
            return;
        async function fetchData() {
            await downloadEpgData(chId, Epg, 1, Shift);
            const newEpg = getSingleEpgNow(Epg,Shift);
            if(!newEpg)
                setEpgNow(false);
            else if(newEpg && (epgNow === false || epgNow.start !== newEpg.start)){
                setEpgNow({...newEpg});
            } 
        }
        fetchData();
      }, [])

    useEffect(() => {
        setFavorite(!!DB.findOne("live",chId,true))
    }, [isPlaying])
    
    useEffect(() => {
        const newEpg = getSingleEpgNow(Epg,Shift);
        if(!newEpg)
            setEpgNow(false);
        else if(newEpg && (epgNow === false || epgNow.start !== newEpg.start)){
            setEpgNow({...newEpg});
        } 
    }, [timer, Epg, Shift, epgNow]);

    const setFavoriteGlob = (event) =>{
        event.stopPropagation();

        if(!!favorite)
            DB.del("live",chId,true)
        else DB.set("live",chId,{id: chId}, true)
        setFavorite(!favorite);
    }

    const formattedName = useMemo(() => formatChannelName(Name), [Name]);

    const hasEpg = epgNow !== false;
    const schedule = hasEpg
      ? `${dateFormat(new Date(epgNow.start), h24Format)} - ${dateFormat(new Date(epgNow.end), h24Format)}`
      : '';

    return (
        <ChannelInfoWrapper>
            <TopRow>
                <ChannelName title={Name}>
                  {formattedName}
                </ChannelName>
                <Favorite $active={!!favorite} onClick={setFavoriteGlob}>
                    <i className={favorite ? "fas fa-star" : "far fa-star"}></i>
                </Favorite>
            </TopRow>
            <ScheduleRow>
                <ScheduleTime>{schedule}</ScheduleTime>
                <ProgramTitle title={epgNow && epgNow.title ? epgNow.title : undefined}>
                    {hasEpg ? epgNow.title : ''}
                </ProgramTitle>
            </ScheduleRow>
            <ProgressWrapper>
                {hasEpg ?
                (<ChannelEpgBar key={chId+ " " +epgNow.start} start={epgNow.start} stop={epgNow.end} isPlaying={isPlaying} />)
                :
                <ChannelEpgBar />
                }
            </ProgressWrapper>
        </ChannelInfoWrapper>
    )
}

export default ChannelEpg

